/**
 * ShortcutOverlay — Keyboard shortcut help panel for EntityDetailPanel
 *
 * Shows available keyboard shortcuts. Toggled with the ? key.
 */

import {
  Modal,
  Table,
  Text,
  Group,
  Kbd,
  Stack,
} from '@mantine/core';
import { SHORTCUT_MAP } from './useDetailKeyboardShortcuts';

interface ShortcutOverlayProps {
  opened: boolean;
  onClose: () => void;
}

export function ShortcutOverlay({ opened, onClose }: ShortcutOverlayProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Keyboard Shortcuts"
      size="sm"
      zIndex={1200}
    >
      <Stack gap="xs">
        <Text size="xs" c="dimmed">Press ? to toggle this overlay</Text>
        <Table>
          <Table.Tbody>
            {SHORTCUT_MAP.map(shortcut => (
              <Table.Tr key={shortcut.key}>
                <Table.Td w={80}>
                  <Group gap={4}>
                    {shortcut.label.includes('+')
                      ? shortcut.label.split('+').map((part, i) => (
                          <span key={i}>
                            {i > 0 && <Text component="span" size="xs" c="dimmed">+</Text>}
                            <Kbd size="xs">{part}</Kbd>
                          </span>
                        ))
                      : <Kbd size="xs">{shortcut.label}</Kbd>
                    }
                  </Group>
                </Table.Td>
                <Table.Td>
                  <Text size="sm">{shortcut.description}</Text>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Stack>
    </Modal>
  );
}
